import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const Filters = props => {
  const monthSeleceted =props.selectedMonth
  return (
      <Fragment>
        <Card>
          <CardBody>
            <CardTitle className="mb-4"></CardTitle>

            <div className="row mb-4">
              <Col lg={8}>
                <Label htmlFor="horizontal-firstname-Input">Month</Label>
                <Input
                    type="month"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    onChange={e => {
                      props.setSelectedMonth(e.target.value)
                    }}
                    value={monthSeleceted}
                />
              </Col>
              <Col lg={4} className="d-flex flex-column justify-content-end">
                <Button type="submit" color="primary" className="w-md">
                  Submit
                </Button>
              </Col>
            </div>
          </CardBody>
        </Card>
      </Fragment>
  )
}
